export default "__VITE_ASSET__CElBoaKp__"